import events from "./events";

const sendEvent = (data) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ...data });
};

const trackCustomEvents = ({ rbEvents, category }, extras) => {
  const data = { ...extras, ...rbEvents[category] };
  sendEvent(data);
};

//const trackCustomEventsV2 =new Promise((resolve, reject)=>{});

const trackCustomEventsV2 = ({ rbEvents, category }, extras) => {
  return new Promise((resolve) => {
    const data = { ...extras, ...rbEvents[category] };
    resolve(sendEvent(data));
  });
};

const trackEventsV2 = (category, extras = {}) => {
  return trackCustomEventsV2(
    {
      rbEvents: events,
      category,
    },
    extras
  );
};
const trackEvents = (category, extras = {}) => {
  trackCustomEvents(
    {
      rbEvents: events,
      category,
    },
    extras
  );
};

export { trackEvents, trackEventsV2 };
